import { ZuiBaseElement } from '@zywave/zui-base';
import { html } from 'lit-html';
import '@zywave/zui-colors';

class ZuiFloatingActionButton extends ZuiBaseElement {
  static get properties() {
    return {
      icon: {
        type: String
      },
      disabled: {
        type: Boolean
      }
    };
  }

  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();
    this.setAttribute('role', 'button');
  }

  firstUpdated() {
    let slot = this.shadowRoot.querySelector('slot');

    if (slot) {
      slot.addEventListener('click', e => {
        if (this.disabled) {
          e.stopPropagation();
          e.preventDefault();
        }
      });
    }
  }

  _renderStyle() {
    return html`
      <style>
        :host button{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-sizing:border-box;box-sizing:border-box;width:5.2rem;height:5.2rem;padding:0;color:var(--zui-button-text-color, #fff);background-color:var(--zui-button-color, var(--zui-gray-800));border:none;border-radius:50%;cursor:pointer;-webkit-box-shadow:0 4px 8px 0 rgba(0,0,0,0.25);box-shadow:0 4px 8px 0 rgba(0,0,0,0.25);-webkit-transition:-webkit-box-shadow 100ms ease-in-out;transition:-webkit-box-shadow 100ms ease-in-out;transition:box-shadow 100ms ease-in-out;transition:box-shadow 100ms ease-in-out, -webkit-box-shadow 100ms ease-in-out}:host button:hover{background-color:var(--zui-button-hover-color, var(--zui-gray-700));-webkit-box-shadow:0 7px 12px 0 rgba(0,0,0,0.25);box-shadow:0 7px 12px 0 rgba(0,0,0,0.25)}:host button:focus{outline:none}:host button:active{background-color:var(--zui-button-active-color, var(--zui-gray-900));-webkit-box-shadow:inset 0 2px 0 var(--zui-button-active-box-shadow, black);box-shadow:inset 0 2px 0 var(--zui-button-active-box-shadow, black);-webkit-transform:translateY(1px);transform:translateY(1px)}:host([icon]) button zui-icon{font-weight:normal;font-style:normal;font-size:var(--zui-button-icon-size, 3rem);line-height:1;letter-spacing:normal;text-transform:none;display:inline-block;white-space:nowrap;word-wrap:normal;direction:ltr;fill:var(--zui-floating-action-button-icon-color, currentColor)}:host([disabled]) button{background-color:var(--zui-gray-200);-webkit-transform:none;transform:none;-webkit-box-shadow:none;box-shadow:none;color:var(--zui-gray-400);outline:none}:host([disabled]) button:hover{cursor:not-allowed}
      </style>
    `;
  }

  render() {
    let iconHtml = '';

    if (this.icon) {
      iconHtml = html`
        <zui-icon icon="${this.icon}"></zui-icon>
      `;
    } else {
      iconHtml = html`
        <slot></slot>
      `;
    }

    return html`
      ${this._renderStyle()} <button ?disabled="${this.disabled}"> ${iconHtml} </button>
    `;
  }

}

customElements.define('zui-fab', ZuiFloatingActionButton);